// ThemeProvider.jsx
import { Icon } from "@chakra-ui/react";
import { color } from "framer-motion";
import React, { createContext, useContext, useState, useEffect } from "react";
import { config } from "../index"
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  useEffect(() => {
    let savedTheme = localStorage.getItem("custom-theme");

    if (!savedTheme) {
      savedTheme = "light";
      localStorage.setItem("custom-theme", savedTheme);
    }

    setTheme(savedTheme);

    if (config === "oldDesign") {
      document.documentElement.setAttribute(
        "data-custom-theme",
        savedTheme
      );
    } else {
      document.documentElement.setAttribute(
        "data-new-theme",
        savedTheme
      );
    }
  }, [config]);



  const toggleTheme = (t) => {
    console.log(t);
    setTheme(t.value);
    if (config === "oldDesign") {
      document.documentElement.setAttribute("data-custom-theme", t.value);
    }
    else {
      document.documentElement.setAttribute("data-new-theme", t.value);
    }
    localStorage.setItem("custom-theme", t.value);
  };

  const availableThemes = [
    {
      name: "Light Mode",
      value: "light",
      Icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1028_19794)">
            <path
              d="M6.66797 10.0013C6.66797 10.8854 7.01916 11.7332 7.64428 12.3583C8.2694 12.9834 9.11725 13.3346 10.0013 13.3346C10.8854 13.3346 11.7332 12.9834 12.3583 12.3583C12.9834 11.7332 13.3346 10.8854 13.3346 10.0013C13.3346 9.11725 12.9834 8.2694 12.3583 7.64428C11.7332 7.01916 10.8854 6.66797 10.0013 6.66797C9.11725 6.66797 8.2694 7.01916 7.64428 7.64428C7.01916 8.2694 6.66797 9.11725 6.66797 10.0013Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.5 10H3.33333M10 2.5V3.33333M16.6667 10H17.5M10 16.6667V17.5M4.66667 4.66667L5.25 5.25M15.3333 4.66667L14.75 5.25M14.75 14.75L15.3333 15.3333M5.25 14.75L4.66667 15.3333"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1028_19794">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      color: null,
    },
    {
      name: "Dark Mode",
      value: "dark",
      Icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1028_19805)">
            <path
              d="M9.99819 2.49885C10.1082 2.49885 10.2174 2.49885 10.3257 2.49885C9.25514 3.49361 8.56702 4.83206 8.38093 6.28154C8.19485 7.73102 8.52257 9.19988 9.30714 10.4328C10.0917 11.6657 11.2835 12.5847 12.6754 13.0301C14.0672 13.4754 15.5711 13.419 16.9257 12.8705C16.4046 14.1243 15.553 15.213 14.4617 16.0207C13.3703 16.8284 12.0802 17.3247 10.7289 17.4567C9.37767 17.5886 8.01591 17.3513 6.78893 16.77C5.56195 16.1887 4.51578 15.2853 3.76201 14.156C3.00824 13.0268 2.57515 11.7141 2.50893 10.358C2.44271 9.0019 2.74584 7.65327 3.386 6.45595C4.02616 5.25863 4.97932 4.25754 6.14383 3.55947C7.30833 2.86139 8.64048 2.49251 9.99819 2.49219V2.49885Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1028_19805">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      color: null,
    },
    {
      name: "Theme 1",
      value: "blue",
      Icon: null,
      color: "#00BFF2",
    },
    {
      name: "Theme 2",
      value: "green",
      Icon: null,
      color: "#2E850F",
    },
    {
      name: "Theme 3",
      value: "black",
      Icon: null,
      color: "#313135",
    },
  ];

  const newavailableThemes = [
    {
      name: "Light Mode",
      value: "light",
      Icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1028_19794)">
            <path
              d="M6.66797 10.0013C6.66797 10.8854 7.01916 11.7332 7.64428 12.3583C8.2694 12.9834 9.11725 13.3346 10.0013 13.3346C10.8854 13.3346 11.7332 12.9834 12.3583 12.3583C12.9834 11.7332 13.3346 10.8854 13.3346 10.0013C13.3346 9.11725 12.9834 8.2694 12.3583 7.64428C11.7332 7.01916 10.8854 6.66797 10.0013 6.66797C9.11725 6.66797 8.2694 7.01916 7.64428 7.64428C7.01916 8.2694 6.66797 9.11725 6.66797 10.0013Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.5 10H3.33333M10 2.5V3.33333M16.6667 10H17.5M10 16.6667V17.5M4.66667 4.66667L5.25 5.25M15.3333 4.66667L14.75 5.25M14.75 14.75L15.3333 15.3333M5.25 14.75L4.66667 15.3333"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1028_19794">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      color: null,
    },
    {
      name: "Dark Mode",
      value: "dark",
      Icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1028_19805)">
            <path
              d="M9.99819 2.49885C10.1082 2.49885 10.2174 2.49885 10.3257 2.49885C9.25514 3.49361 8.56702 4.83206 8.38093 6.28154C8.19485 7.73102 8.52257 9.19988 9.30714 10.4328C10.0917 11.6657 11.2835 12.5847 12.6754 13.0301C14.0672 13.4754 15.5711 13.419 16.9257 12.8705C16.4046 14.1243 15.553 15.213 14.4617 16.0207C13.3703 16.8284 12.0802 17.3247 10.7289 17.4567C9.37767 17.5886 8.01591 17.3513 6.78893 16.77C5.56195 16.1887 4.51578 15.2853 3.76201 14.156C3.00824 13.0268 2.57515 11.7141 2.50893 10.358C2.44271 9.0019 2.74584 7.65327 3.386 6.45595C4.02616 5.25863 4.97932 4.25754 6.14383 3.55947C7.30833 2.86139 8.64048 2.49251 9.99819 2.49219V2.49885Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1028_19805">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      color: null,
    },
    {
      name: "Theme 1",
      value: "blue",
      Icon: null,
      color: "#00BFF2",
    },
    {
      name: "Theme 2",
      value: "green",
      Icon: null,
      color: "#2E850F",
    },
    {
      name: "Theme 3",
      value: "black",
      Icon: null,
      color: "#313135",
    },
  ]





  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, availableThemes, newavailableThemes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
